<!--
 * @Author: lan.h
 * @Date: 2022-02-21 16:31:59
 * @LastEditors:  
 * @LastEditTime: 2022-07-06 17:21:28
 * @Description: 活跃赛道
-->
<template>
  <div class="track">
    <div class="mode-title">
      <span class="title-p">活跃赛道</span>
      <div class="comp-src-name">活跃赛道数据由 
        <img  @click="haddleApplyTry2(32)" :src="$store.state.static_img_url+'pic/logo.png'" alt="动脉橙" > 提供支持</div>
    </div>
    <div class="track-content">
      <Spin fix v-if="loading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
      <div class="track-header">
        <div class="left">
          <img :src="$store.state.static_img_url+'pic/vcbeat/30days.png'">
          <span class="track-title">赛道融资统计<span v-if="type == 2">(RMB)</span></span>
        </div>
        <Dropdown @on-click="haddleDropdown($event)" @on-visible-change="changeStatus">
          <a href="javascript:void(0)">
            {{type == 1 ? '事件数(起)' : '融资额(千万)'}}
            <i class="iconfont" v-if="type_status">&#xe73c;</i>
            <i class="iconfont" v-else>&#xe73d;</i>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem :name="1" :selected="type == 1">事件数(起)</DropdownItem>
            <DropdownItem :name="2" :selected="type == 2">融资额(千万)</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <ul>
        <li v-for="item, index in track" :key="index">
          <Tooltip content="查看赛道详情" placement="top-start">
            <a @click="goToTrackDetail" :href="$store.state.index_path + '/trackDetail?tag=' + item.id" target="_blank">
              <div class="left">
                <p class="l1-ellipsis">{{item.name}}</p>
                <!-- <a @click="goToTrackDetail" :href="$store.state.index_path + '/trackDetail?tag=' + item.id" target="_blank">赛道详情</a> -->
              </div>
              <div class="line" :style="{width: 'calc((100% - 150px)*'+ item.eventCount/max + ')' }" v-if="type == 1"></div>
              <div class="line" :style="{width: 'calc((100% - 150px)*'+ item.eventAmount/max + ')' }" v-else></div>
              <span class="num">{{type == 1 ? item.eventCount : dealAmount(item.eventAmount)}}</span>
            </a>
          </Tooltip>
        </li>
      </ul>
      <div class="flash-more" @click="toEventList()">
        <a>查看更多</a>
      </div>
    </div>
  </div>
</template>

<script>
import { activetrack } from '../../service'
export default {
  inject: ['haddleApplyTry2'],
  props: {
    num: {
      // 显示的活跃赛道的数量
      default: 5
    },
    pageType: {
      default: ''    //1首页
    }
  },
  data() {
    return {
      track: [],
      type: 1,     //【分类，1 按融资数量统计；2 按融资金额统计】
      maxCount: 0,
      maxAmout: 0,
      type_status: '',
      loading: false,
      max: 0,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      let res = await activetrack({
        type: this.type
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      this.loading = false
      if (res.code == 0) {
        this.$set(this.$data, 'track', res.data.slice(0,this.num))
        let arr = this.track.map((item, index) => {
          return this.type == 1 ? item.eventCount : item.eventAmount
        })
        this.max = Math.max(...arr)
        // this.maxCount = Math.max.apply(Math, this.track.map(function(o) {return o.eventCount}))
        // this.maxAmout = Math.max.apply(Math, this.track.map(function(o) {return o.eventAmount}))
        
      } else {
        this.$Message.error(res.msg)
      }
    },
    haddleDropdown(id) {
      this.type = id
      this.getList()
      let type = id == 2 ? '右侧活跃赛道(切换融资额)' : '右侧活跃赛道(切换事件数)'
      if(this.pageType == '1'){
        _czc.push(['_trackEvent', '首页(新)', type, '点击量'])
      }
      else if(this.pageType == '3') {
        _czc.push(['_trackEvent', '看赛道(新)', type, '点击量'])
      }
    },
    changeStatus(status) {
      this.type_status = status
    },
    /**
     * @description: 处理金额  千万
     * @param {*} a
     * @return {*}
     */    
    dealAmount(a) {
      if(a==null||a==0){
        return '--';
      }
      if(a/10000000>=1){
        return  (a/10000000).toFixed(2) 
      }
    },
    toEventList() {
      const href = this.$store.state.index_path + '/eventList'
      window.open(href, '_blank')
      if(this.pageType == '1'){
        _czc.push(['_trackEvent', '首页(新)', '右侧活跃赛道(查看更多)', '点击量'])
      }
      else if(this.pageType == '3') {
        _czc.push(['_trackEvent', '看赛道(新)', '右侧活跃赛道(查看更多)', '点击量'])
      }
    },
    goToTrackDetail() {
      // const href = this.$store.state.index_path + '/trackDetail?tag=' + id
      // window.open(href, '_blank')
      if(this.pageType == '1'){
        _czc.push(['_trackEvent', '首页(新)', '右侧活跃赛道(赛道详情)', '点击量'])
      }
      else if(this.pageType == '3') {
        _czc.push(['_trackEvent', '看赛道(新)', '右侧活跃赛道(赛道详情)', '点击量'])
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.track
  &-content 
    margin-top 20px
    position relative
    >>> .ivu-spin-fix
      .ivu-spin-main
        top 50% !important
    .track-header
      display flex 
      align-items center
      justify-content space-between
      .left
        display flex
        align-items center
        img 
          margin-right 10px
        .track-title
          font-size 14px
          font-weight 500
          color #333333
          line-height 1
      >>>.ivu-dropdown
        .ivu-dropdown-rel
          border 1px solid #E0E0E0
          height 26px
          a 
            font-size 12px
            font-weight 500
            color #333333
            line-height 26px
            padding 6px 8px
            i 
              font-size 12px
              color #FF8824
    .l1-ellipsis
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
      word-break break-all
    ul 
      li
        .ivu-tooltip
          width 100%
          margin-top 7px
          font-weight 500
          display flex
          align-items center
          flex-wrap wrap
          justify-content center
          height 42px
          cursor pointer
          transition all 0.5s
          &:hover
            background #FFFFFF
            box-shadow 0px 4px 10px 0px rgba(0,0,0,0.1000)
            padding-left 12px
            .left
              p
                color #FF8824
          .left
            width 80px
            // padding-left 12px
            padding-right 15px
            p
              width 100%
              font-size 13px
              color #333333
              line-height 14px
            a
              display block
              margin-top 5px
              font-size 12px
              color #FF8824
              position relative
              line-height 1
              -webkit-transition all 0.5s
              transition all 0.5s
              &:hover
                color #FF6600
              &::after
                border solid #FF8824
                border-width 0 1px 1px 0
                display inline-block
                padding 2px
                transform rotate(-45deg)
                position absolute
                top 3px
                left 50px
                content ''
          .line
            height 12px
            background linear-gradient(90deg, #FF8824, #FFC697)
            position relative
            transition all 0.5s
            &::after
              position absolute
              right -11px
              top 0
              content ''
              width 0
              height 0
              border-top 12px solid #FFC697
              border-right 12px solid transparent
          .num
            padding-left 20px
            width 70px
            display block
        .ivu-tooltip-rel
          a
            display flex
            align-items center
  .flash-more
    margin-top 20px
</style>